import { AppState } from 'services/types';
import { SelectedSprayEventIdsForSubmissionState } from './types';

const selectSelectedSprayEventIdsForSubmission = (
    state: AppState
): SelectedSprayEventIdsForSubmissionState =>
    state.selectedSprayEventIdsForSubmission;

export { selectSelectedSprayEventIdsForSubmission };
